<template>
    <a-form-model
        layout="horizontal"
        :model="form"
        :labelCol="{ span: 4 }"
        :wrapperCol="{ span: 20 }"
        class="register-form"
        ref="registerForm"
        :rules="rules"
    >
        <a-form-model-item label="姓名" prop="realName">
            <a-input v-model="form.realName" size="large" placeholder="请输入"> </a-input>
        </a-form-model-item>
        <a-form-model-item label="用户名" prop="userName">
            <a-input v-model="form.userName" size="large" placeholder="由6-10位数字、字母组成"> </a-input>
        </a-form-model-item>
        <a-form-model-item label="密码" prop="password">
            <a-input-password
                v-model="form.password"
                size="large"
                placeholder="6位数以上，数字、符号、字母任意两种组合"
            >
            </a-input-password>
        </a-form-model-item>
        <a-form-model-item label="确认密码" prop="checkPass">
            <a-input-password v-model="form.checkPass" size="large" placeholder="请再次输入密码"> </a-input-password>
        </a-form-model-item>
        <a-form-model-item label="手机号码" prop="phone">
            <a-input v-model="form.phone" size="large" placeholder="请输入"> </a-input>
        </a-form-model-item>
        <a-form-model-item label="注册邮箱" prop="email">
            <a-input v-model="form.email" size="large" placeholder="请输入"> </a-input>
        </a-form-model-item>
    </a-form-model>
</template>

<script>
import { validateUsername, validatePass, checkEmail, checkPhone } from '@/common/utils';

export default {
    data() {
        const validatePass2 = (rule, value, callback) => {
            if (value === '') {
                return callback(new Error('确认密码不能为空'));
            } else if (value !== this.form.password) {
                return callback(new Error('两次输入密码不一致!'));
            }
            return callback();
        };

        return {
            form: {
                realName: '',
                userName: '',
                password: '',
                checkPass: '',
                phone: '',
                email: ''
            },
            rules: {
                realName: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
                userName: [
                    { required: true, message: '用户名不能为空', trigger: 'blur' },
                    { validator: validateUsername, trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '密码不能为空', trigger: 'blur' },
                    { validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { required: true, message: '请确认密码', trigger: 'blur' },
                    { validator: validatePass2, trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '手机号不能为空', trigger: 'blur' },
                    { validator: checkPhone, trigger: 'blur' }
                ],
                email: [{ validator: checkEmail, trigger: 'blur' }]
            }
        };
    },
    methods: {
        validate() {
            return new Promise(res => {
                this.$refs.registerForm.validate(valid => {
                    if (valid) {
                        res(true);
                    } else {
                        res(false);
                    }
                });
            });
        },

        resetFields() {
            this.$refs.registerForm.resetFields();
        }
    }
};
</script>

<style lang="scss" scoped></style>
